<template>
  <div id="carouselControls" class="carousel slide mb-4" data-interval="false">
    <div class="carousel-inner shadow h-100 mb-2">
      <div v-for="(item, i) in carouselData" :key="item.id" class="carousel-item bg-white rounded overflow-hidden" :class="{ active: i == 0 }">
        <div class="d-flex flex-column flex-lg-row h-100 w-100">
          <div class="p-4 pl-lg-5 w-50 carouselBody  order-2 order-lg-0 " :style="{ 'min-height': carouselHeight }">
            <h2 style="font-size: 22px">{{ item.title.rendered }}</h2>
            <p v-html="item.acf.body" class="mb-0 pb-1"></p>
          </div>
          <div class="w-50 order-0 order-lg-2 carouselImage">
            <figure class="m-0 w-100 h-100">
              <img class="w-100 h-100 object-fit-cover object-position-center" :src="item.acf.image.url" :alt="item.acf.image.alt" />
            </figure>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row no-gutters rounded">
      <div class="p-4 pl-5 col-12 col-lg-6 order-2 order-lg-1 carouselBody" style="min-height: 394px">
        <h2 style="font-size: 22px">Välkommen till Mina Sidor</h2>
        <p class="mb-0 pb-1">
          Här på Mina Sidor kan du se dina fakturor, avtal, din energianvändning och en massa annan nyttig information. <br /><br />
          Passa gärna på att uppdatera dina kontaktuppgifter under Min profil om du inte redan har gjort det. <br /><br />Välkommen att kontakta oss
          om du funderar på något. Våra kontaktuppgifter hittar du längre ner på den här sidan.
        </p>
      </div>
      <div class="col-12 col-lg-6 order-1 order-lg-2 carouselImage">
        <figure class="m-0 h-100">
          <img class="w-100 h-100 object-fit-cover object-position-center" src="https://www.gavleenergi.se/assets/Mina_sidor_geab.jpg" alt="" />
        </figure>
      </div>
    </div> -->

    <div
      v-if="carouselData.length > 1"
      class="carousel-control-prev carouselController bg-white"
      style="width: 8%"
      href="#carouselControls"
      role="button"
      data-slide="prev">
      <i class="carouselControllerIcon fa-thin fa-angle-left" aria-hidden="true"></i>
      <span class="sr-only">Previous</span>
    </div>
    <div
      v-if="carouselData.length > 1"
      class="carousel-control-next carouselController bg-white"
      style="width: 8%"
      href="#carouselControls"
      role="button"
      data-slide="next">
      <i class="carouselControllerIcon fa-thin fa-angle-right" aria-hidden="true"></i>
      <span class="sr-only">Nästa</span>
    </div>
    <ol class="carousel-indicators position-relative">
      <li v-for="(item, i) in carouselData" :key="item.id" data-target="#carouselControls" :data-slide-to="i" :class="{ active: i == 0 }"></li>
    </ol>
  </div>

  <ComponentStyles>
    .carousel-indicators > li { height: 12px; width: 12px; border-radius: 50%;} .carouselController { opacity: 0; } .carouselController:hover {
    opacity: .5; } .carouselControllerIcon { font-size: 3rem; color: black; } @media screen and (max-width: 992px) { .carouselImage{ height: 200px
    !important; } 
    .carouselImage, .carouselBody {
      width: 100% !important; } }
  </ComponentStyles>
</template>
<script>
import ComponentStyles from "../componentStyles.vue";
import cookies from "vue-cookies";
export default {
  components: { ComponentStyles },
  props: ["url"],
  data() {
    let cItemHeight = null;
    let contract_type = {
      elnat: cookies.get("pfu_elnat"),
      elhandel: cookies.get("pfu_elhandel"),
      omt_status: cookies.get("pfu_omteckningstatus"),
      fjv: cookies.get("pfu_fjarrvarme"),
      bb: cookies.get("pfu_bredband"),
      tv: cookies.get("pfu_tv"),
      typ1: cookies.get("pfu_avtal").indexOf(1) != -1 ? "true" : "false",
      typ2: cookies.get("pfu_avtal").indexOf(2) != -1 ? "true" : "false",
      typ3: cookies.get("pfu_avtal").indexOf(3) != -1 ? "true" : "false",
      typ4: cookies.get("pfu_avtal").indexOf(4) != -1 ? "true" : "false",
      typ5: cookies.get("pfu_avtal").indexOf(5) != -1 ? "true" : "false",
      typ6: cookies.get("pfu_avtal").indexOf(6) != -1 ? "true" : "false"
    };

    return {
      pp: cookies.get("pfu_privateperson"),
      contract_type,
      carouselData: [],
      cItemHeight,
    };
  },

  methods: {
    fetchCards() {
      fetch(this.url + "/wp-json/wp/v2/slides")
        .then((response) => response.json())
        .then((data) =>
          data.sort(function (a, b) {
            return a.menu_order - b.menu_order;
          })
        )
        .then((sortedData) => (this.carouselData = sortedData.filter(this.filterData)));
    },

    filterData(item) {
      let temp = false;
      let audience = item.acf.audience;

      if (audience == 3 || (audience == 1 && this.pp == "true") || (audience == 2 && this.pp == "false")) {
        item.acf.contract_type.map((ct) => {
          if (ct == "omt_status") {
            if (this.contract_type[ct] == 1 || this.contract_type[ct] == 2) {
              temp = true;
            }
          } else if (this.contract_type[ct] == "true") {
            temp = true;
          }
        });
      }

      return temp;
    },
  },

  computed: {
    carouselHeight: function () {
      return this.cItemHeight + "px";
    },
  },
  mounted() {
    this.fetchCards();

    //visar alla slides snabbt, sätter höjd till den högsta så att sidan inte hoppar när karusellen byter bild.
    setTimeout(() => {
      let citems = document.querySelectorAll(".carouselBody");

      citems.forEach((element) => {
        element.parentElement.parentElement.style.display = "block";
        if (element.offsetHeight > this.cItemHeight) {
          this.cItemHeight = element.offsetHeight;
        }
        console.log(this.cItemHeight);
        element.parentElement.parentElement.style.removeProperty("display");
      });
    }, 1200);
  },
};
</script>
